import Vue from "vue";
import makeAppendSettingsMixin from "@/mixins/makeAppendSettingsMixin";
import {mixins} from "atom";

const {makeLoggerMixin, makeFeaturesMixin} = mixins;

export default container => {
    container.declare("Vue", ({features, logger, settings}) => {
        Vue.config.productionTip = false;
        //register mixins globally
        Vue.mixin(makeLoggerMixin(logger));
        Vue.mixin(makeAppendSettingsMixin(settings));
        Vue.mixin(makeFeaturesMixin(features));
        return Vue;
    });

    container.declare("$set", ({Vue}) => Vue.set);
    container.declare("$delete", ({Vue}) => Vue.delete);
    container.declare("$rendering", ({Vue}) => Vue.nextTick);
};
